import { BasketState, BasketItem, PaymentResult } from '@/contracts/store/BasketContracts'

export const Basket =
{
    namespaced: true,
    state: (): BasketState => (
    {
        items: [] as Array<BasketItem>,
        transactionReference: '',
        paymentResult: null
    }),
    getters:
    {
        getBasket(state: BasketState): Array<BasketItem>
        {
            return state.items
        },
        getBasketCount(state: BasketState): number
        {
            return state.items.length
        },
        getTransactionReference(state: BasketState): string
        {
            return state.transactionReference
        },
        getPaymentResult(state: BasketState): PaymentResult | null
        {
            return state.paymentResult
        }
    },
    mutations:
    {
        addToBasket(state: BasketState, item: BasketItem): void
        {
            state.items.push(item)
        },
        removeFromBasket(state: BasketState, index: number): void
        {
            state.items.splice(index, 1)
        },
        resetBasket(state: BasketState): void
        {
            state.items = []
            state.transactionReference = ''
            state.paymentResult = null
        },
        setTransactionReference(state: BasketState, transactionReference: string): void
        {
            state.transactionReference = transactionReference
        },
        setPaymentResult(state: BasketState, paymentResult: PaymentResult): void
        {
            state.paymentResult = paymentResult
        }
    }
}
